import { IGuid } from './ITypes';
import { IContact, IPerson } from './IContact';
import { ISubscriptions } from './ISubscription';
import { IAccount } from './IAccount';
import { Repository } from '../fetch';
import { IUserInfo, IUserPermissions } from '../userRole';
import { ObjectTransformation } from '../../common/Controls/ObjectTransformation';
import { objectToJsonAuditComment, PropertyToValueDict } from '../changesToChangeLog';

export type ProductType = 'CRM' | 'XRM';
export type PaymentPeriod = 'Monthly' | 'Yearly';
export type OrganizationType =
    'CustomerDemo' |
    'CustomerDevelopment' |
    'CustomerProduction' |
    'CustomerTest' |
    'PartnerDemo' |
    'PartnerDevelopment' |
    'PartnerProduction' |
    'PartnerTest' |
    'RescoDemo' |
    'RescoDevelopment' |
    'RescoProduction' |
    'RescoTest';

export type IEmails = string[];

export interface IOrganization {
    Id: IGuid;
    Name: string;
    Url: string;
    CreatedOn: string;

    OrganizationType?: OrganizationType | null;
    Type?: ProductType | null;
    PaymentPeriod?: PaymentPeriod | null;

    Subscriptions?: ISubscriptions | null;

    LicensesAutoAssign?: boolean;
    OfflineLicensesEnabled?: boolean;
    SendLicensesNotificationsToWoodfordUsers?: boolean;

    Customer?: IAccount | null;
    CustomerContact?: IPerson | null;
    Partner?: IAccount | null;
    PartnerContact?: IPerson | null;

    PrimaryLicensesNotificationRecepients?: IEmails | null;
    Comments?: string | null;

    RowVersion?: string | null;

    AuditComment?: string | null;
}

export const recipientsTransformation: ObjectTransformation<IEmails, string> = {
    objectToValue: (a: IEmails | null): string | null =>
        a && Array.isArray(a) ? a.join('; ') : a,

    valueToObject: (t: string | null): IEmails | null => {
        if (!t)
            return null;
        const separator = t.indexOf(';') > 0 ? ';' : (t.indexOf(',') > 0 ? ',' : ' ');
        const recipients = t ? t.split(separator) : null;
        if (recipients) {
            const arr = [];
            for (let i = 0; i < recipients.length; i++) {
                const r = recipients[i] ? recipients[i].trim() : null;
                if (r && r.length >= 5)   // x@y.z
                    arr.push(r);
            }
            return arr.length ? arr : null;
        }
        return null;
    }
}

export const DefaultOrganization: IOrganization = {
    Id: '',
    Name: '',
    Url: '',
    CreatedOn: Date.now.toString(),
    LicensesAutoAssign: false,
    OfflineLicensesEnabled: false,
    SendLicensesNotificationsToWoodfordUsers: false
}

export type IWoodfordUsers = Array<IContact>;

const propertyToValue: PropertyToValueDict = {
    Customer: (value: IAccount | null) => !value ? null : value.Name,
    CustomerContact: (value: IPerson | null) => !value ? null : value.Name,
    Partner: (value: IAccount | null) => !value ? null : value.Name,
    PartnerContact: (value: IPerson | null) => !value ? null : value.Name,
    OrganizationType: (value: any) => {
        const type = value ? Repository.OrganizationTypes[value] : undefined;
        return type ? type : 'OrganizationType reset';
    },
    Id: () => undefined,
    RowVersion: () => undefined,
    Subscriptions: () => undefined,
    Type: (value: any) => value ? value : 'Type reset',
    PrimaryLicensesNotificationRecepients: (value: any) => !value ? 'Recipients deleted' : 'Recipients changed'
}

export const buildOrganizationAuditComment = (changes: any, oldValues: any, name?: string): string | null =>
    objectToJsonAuditComment(changes, oldValues, propertyToValue, "O", name);

export const getPermissions = (user: IUserInfo, org: IOrganization | null | undefined): IUserPermissions => {
    const privileges: IUserPermissions = { ...user.permissions };
    /*
        if (privileges.editPermissions !== EditPermissions.Full && org && org.OrganizationType) {
            privileges.canEdit = (privileges.editPermissions & EditPermissions.CanEditPartner) === EditPermissions.CanEditPartner || org.OrganizationType === "CustomerProduction";
            privileges.canDelete = privileges.canEdit;
        }*/
    return privileges;
}